import { Injectable } from '@angular/core';
import { Browser } from '@capacitor/browser';

@Injectable({
    providedIn: 'root',
})

export class BrowserNativeService {

    public browser = Browser

    constructor() {

    }

    /**
     * Apre il browser di sistema (SFSafariViewController / Custom Tabs: l'utente
     * non esce dall'app) e ritorna quando viene chiuso.
     *
     * ponytail: unico segnale d'uscita `browserFinished`, registrato PRIMA di
     * `open` perché su Custom Tabs la chiusura può arrivare subito. Chi chiama
     * NON deduce nulla dalla chiusura: va a chiedere l'esito a chi lo sa.
     */
    /**
     * Chiude il pannello che stiamo mostrando. Serve quando l'esito arriva
     * mentre l'utente e' ancora davanti alla pagina del PSP: dopo la conferma
     * della banca il browser resta aperto sul sito e non torna all'app da solo
     * (il rientro automatico vorrebbe un universal link sul dominio corrente).
     * Chiudendolo noi, l'utente si ritrova nell'app col risultato.
     *
     * Best-effort: se il pannello e' gia' chiuso il plugin puo' lamentarsi, e
     * non e' un errore che debba risalire.
     */
    async close(): Promise<void> {
        try { await Browser.close(); } catch { /* gia' chiuso */ }
    }

    async openAndWaitClose(url: string): Promise<void> {
        let onClosed: () => void = () => { };
        const closed = new Promise<void>((resolve) => { onClosed = resolve; });
        const handle = await Browser.addListener('browserFinished', () => onClosed());
        try {
            await Browser.open({ url, presentationStyle: 'popover' });
            await closed;
        } finally {
            await handle.remove().catch(() => { });
        }
    }
}
